import React, { useEffect, useState } from 'react';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import TextField from "@mui/material/TextField";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Dialog from '@mui/material/Dialog';
import { Box, CircularProgress, DialogContent } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { PRIMARY_THEME_COLOR_SHADE_1 } from "../../../lib/constants";
import MultipleSelectChip from '../../PartnerStatus/components/Edit/MultipleSelectChip';
import AlertDialog from '../../../components/AlertDialog/index.es6';
import { getPartnerGuid } from '../../../lib/access.es6';
import { filterRolesByPartner } from '../utils/filterRolesByPartner';

const AddPartnerUser = (props) => {
  const [firsName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmpassword] = useState('');
  const [allRolesdata, setAllRoles] = useState([]);
  const [currentRoles, setCurrentRoles] = useState([]);
  const [isAgentCheck, setIsAgentCheck] = useState(false);
  const [dynamicAttrs, setDynamicAttrs] = useState([]);

  useEffect(() => {
    var partnerGuid = getPartnerGuid();
    var filtered = filterRolesByPartner(props.allRoles || [], partnerGuid);
    setAllRoles(filtered);
  }, [props.allRoles]);

  useEffect(() => {
    ValidatorForm.addValidationRule('isvalidemail', function(value) {
      //eslint-disable-next-line
      return value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    });

    ValidatorForm.addValidationRule('isPasswordMatch', function(value) {
      return password === confirmPassword;
    });

    ValidatorForm.addValidationRule('isvalidpassword', function(value) {
      return value.match(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/);
    });

    return function cleanup() {
      ValidatorForm.removeValidationRule('isvalidemail');
      ValidatorForm.removeValidationRule('isPasswordMatch');
      ValidatorForm.removeValidationRule('isvalidpassword');
    };
  });

  const handleChange = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    if (name === 'name') setFirstName(value);
    if (name === 'lastname') setLastName(value);
    if (name === 'Username') setUserName(value);
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
    if (name === 'confirmpassword') setConfirmpassword(value);
  };

  const addAttr = () => {
    setDynamicAttrs(function(prev) {
      return prev.concat([{ key: '', value: '' }]);
    });
  };

  const removeAttr = (index) => {
    setDynamicAttrs(function(prev) {
      return prev.filter(function(_, i) { return i !== index; });
    });
  };

  const handleAttrKeyChange = (index, key) => {
    setDynamicAttrs(function(prev) {
      return prev.map(function(a, i) {
        return i === index ? Object.assign({}, a, { key: key }) : a;
      });
    });
  };

  const handleAttrValueChange = (index, value) => {
    setDynamicAttrs(function(prev) {
      return prev.map(function(a, i) {
        return i === index ? Object.assign({}, a, { value: value }) : a;
      });
    });
  };

  const handleSubmit = () => {
    var partnerGuid = getPartnerGuid();
    var attrsPayload = {};
    dynamicAttrs.forEach(function(a) {
      if (a.key) {
        attrsPayload[a.key] = [a.value];
      }
    });
    attrsPayload.partners = [partnerGuid];
    attrsPayload.isAgent = [String(isAgentCheck)];

    var payload = {
      username: userName,
      groups: currentRoles.map(function(role) { return role.path.substring(1); }),
      lastName: lastName,
      firstName: firsName,
      email: email,
      attributes: attrsPayload,
      enabled: true,
      credentials: [
        {
          type: 'password',
          value: password,
          temporary: false,
        },
      ],
    };
    props.addUser(payload);
  };

  const reset = () => {
    setFirstName('');
    setLastName('');
    setUserName('');
    setEmail('');
    setPassword('');
    setConfirmpassword('');
    setCurrentRoles([]);
    setIsAgentCheck(false);
    setDynamicAttrs([]);
  };

  const handleUserCreatedSuccessfully = () => {
    props.resetAddUserSuccessAlert();
    reset();
    props.closeAddUserDialog();
    props.refreshUsers();
  };

  return (
    <>
      <Dialog
        open={props.openAddUserDialog}
        fullWidth
        maxWidth="lg"
        onClose={props.closeAddUserDialog}
        fullScreen
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ background: PRIMARY_THEME_COLOR_SHADE_1 }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.closeAddUserDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Create User
            </Typography>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <div style={{ marginTop: '2%' }}>
            <Box sx={{ width: '100%' }}>
              <AlertDialog
                custom
                show={props.showAddUserProgressAlert}
                size="sm"
                style={{ marginTop: '0', top: '30vh' }}
                confirmBtnText={'ok'}
                showCancel={false}
                showConfirm={false}
                cancelBtnText={'cancel'}
                showTitle={false}
                confirmBtnCssClass
              >
                <CircularProgress />
                <h2>Adding User</h2>
              </AlertDialog>

              <AlertDialog
                success
                show={props.showAddUserSuccessAlert}
                size="sm"
                title={'User added successfully'}
                style={{ marginTop: '0', top: '30vh' }}
                onConfirm={() => { handleUserCreatedSuccessfully(); }}
                confirmBtnText={'ok'}
                showCancel={false}
                showConfirm={false}
                cancelBtnText={'cancel'}
                confirmBtnCssClass
              >
                <div>
                  <Button variant="contained" onClick={() => { handleUserCreatedSuccessfully(); }} style={{ background: 'green' }}>Ok</Button>
                </div>
              </AlertDialog>

              <AlertDialog
                danger
                show={props.showAddUserErrorAlert}
                size="sm"
                title={'Error adding user'}
                style={{ marginTop: '0', top: '30vh' }}
                onConfirm={props.resetAddUserErrorAlert}
                confirmBtnText={'Try again'}
                showCancel={false}
                confirmBtnCssClass
              >
                <div>
                  <p>{props.addUserError && props.addUserError.errorMessage ? props.addUserError.errorMessage : 'Error Adding User'}</p>
                </div>
              </AlertDialog>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      checked={isAgentCheck}
                      onChange={function(e) { setIsAgentCheck(e.target.checked); }}
                      control={<Checkbox size="small" />}
                      label="Is Agent?"
                      labelPlacement="start"
                    />
                  </FormGroup>
                </Grid>
              </Grid>

              <ValidatorForm onSubmit={() => handleSubmit()}>
                <Grid container spacing={2}>
                  <Grid item md={4} sm={4} xs={12}>
                    <TextValidator
                      onChange={handleChange}
                      label={'First Name'}
                      value={firsName}
                      name="name"
                      fullWidth
                      variant="outlined"
                      type="text"
                      placeholder="First Name"
                      validators={['required']}
                      errorMessages={['Please enter first name']}
                    />
                  </Grid>
                  <Grid item md={4} sm={4} xs={12}>
                    <TextValidator
                      onChange={handleChange}
                      label={'Last Name'}
                      value={lastName}
                      name="lastname"
                      fullWidth
                      variant="outlined"
                      type="text"
                      placeholder="Last Name"
                      validators={['required']}
                      errorMessages={['Please enter last name']}
                    />
                  </Grid>
                  <Grid item md={4} sm={4} xs={12}>
                    <TextValidator
                      onChange={handleChange}
                      label={'Username'}
                      value={userName}
                      name="Username"
                      fullWidth
                      variant="outlined"
                      type="text"
                      placeholder="Username"
                      validators={['required']}
                      errorMessages={['Please enter username']}
                    />
                  </Grid>
                  <Grid item md={4} sm={4} xs={12}>
                    <TextValidator
                      onChange={handleChange}
                      label={'Email'}
                      value={email}
                      name="email"
                      fullWidth
                      variant="outlined"
                      type="email"
                      placeholder="Email"
                      validators={['required', 'isvalidemail']}
                      errorMessages={['Please enter an email address', 'Please enter a valid email address']}
                    />
                  </Grid>
                  <Grid item md={4} sm={4} xs={12}>
                    <TextValidator
                      onChange={handleChange}
                      label={'Password'}
                      value={password}
                      id="password"
                      name="password"
                      fullWidth
                      variant="outlined"
                      type="password"
                      placeholder="Password"
                      validators={['required', 'isvalidpassword']}
                      errorMessages={['Please enter password', 'Password must be 6-16 characters with at least one number and one special character.']}
                    />
                  </Grid>
                  <Grid item md={4} sm={4} xs={12}>
                    <TextValidator
                      onChange={handleChange}
                      label={'Confirm Password'}
                      value={confirmPassword}
                      id="confirmpassword"
                      name="confirmpassword"
                      fullWidth
                      variant="outlined"
                      type="password"
                      placeholder="Confirm Password"
                      validators={['required', 'isPasswordMatch']}
                      errorMessages={['Please enter password', 'Passwords do not match']}
                    />
                  </Grid>

                  {!isAgentCheck && (
                    <Grid item md={4} sm={4} xs={12}>
                      <MultipleSelectChip
                        constantFields={allRolesdata}
                        fieldLabel="roles"
                        fields={currentRoles}
                        setFields={setCurrentRoles}
                      />
                    </Grid>
                  )}

                  {dynamicAttrs.map(function(attr, index) {
                    return (
                      <Grid item xs={12} key={index}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item md={5} sm={5} xs={12}>
                            <TextField
                              label="Attribute Name"
                              value={attr.key}
                              fullWidth
                              variant="outlined"
                              placeholder="e.g. staffId"
                              onChange={function(e) { handleAttrKeyChange(index, e.target.value); }}
                            />
                          </Grid>
                          <Grid item md={6} sm={6} xs={10}>
                            <TextField
                              label="Value"
                              value={attr.value}
                              fullWidth
                              variant="outlined"
                              onChange={function(e) { handleAttrValueChange(index, e.target.value); }}
                            />
                          </Grid>
                          <Grid item md={1} sm={1} xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton
                              onClick={function() { removeAttr(index); }}
                              size="small"
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}

                  <Grid item xs={12}>
                    <Button
                      startIcon={<AddIcon />}
                      onClick={addAttr}
                      variant="outlined"
                      size="small"
                      style={{ borderColor: PRIMARY_THEME_COLOR_SHADE_1, color: PRIMARY_THEME_COLOR_SHADE_1 }}
                    >
                      Add Attribute
                    </Button>
                  </Grid>

                  <Grid item md={4} sm={4} xs={12}>
                    <Stack spacing={2} direction="row" style={{ marginTop: '10px', marginLeft: '30px' }}>
                      <Button variant="contained" fullWidth type="submit" style={{ background: '#032a37' }}>
                        Create User
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </ValidatorForm>
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddPartnerUser;
